import React from "react";
import PropTypes from "prop-types";
import SVG from "components/elements/svg";

const STATE_READY = 1;
const STATE_PROCESSING = 2;
const STATE_DONE = 3;
const STATE_ERROR = 4;

class SubmitButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonState: props.state,
    };
  }

  componentDidMount() {
    this.minWidth = this.button.offsetWidth;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ buttonState: nextProps.state });
  }

  componentDidUpdate() {
    const { state, onUpdate } = this.props;

    if (state > STATE_PROCESSING) {
      this.resetButton = setTimeout(() => {
        this.setState({ buttonState: STATE_READY });
        onUpdate(STATE_READY);
      }, 3 * 1000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.resetButton);
  }

  stateClassName(state) {
    if (state === STATE_READY) {
      return "ready";
    }
    if (state === STATE_PROCESSING) {
      return "processing";
    }
    if (state === STATE_DONE) {
      return "done";
    }
    if (state === STATE_ERROR) {
      return "error";
    }

    return null;
  }

  shouldBeDisabled(state) {
    if (state > STATE_READY) {
      return true;
    }

    return false;
  }

  render() {
    const { children, className, type, onClick } = this.props;
    const { buttonState } = this.state;

    return (
      <button
        type={type}
        className={`submit-button ${className} ${this.stateClassName(
          buttonState,
        )}`}
        disabled={this.shouldBeDisabled(buttonState)}
        ref={(el) => {
          this.button = el;
        }}
        onClick={onClick}
        style={{ minWidth: `${this.minWidth ? this.minWidth : 1}px` }}
      >
        {buttonState === STATE_READY && children}
        {buttonState === STATE_PROCESSING && (
          <SVG src="spinner" className="spinner" />
        )}
        {buttonState === STATE_DONE && <SVG src="mark" className="tick" />}
        {buttonState === STATE_ERROR && <SVG src="x" className="error" />}
      </button>
    );
  }
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string,
  state: PropTypes.oneOf([1, 2, 3, 4]),
  onUpdate: PropTypes.func,
  onClick: PropTypes.func,
};

SubmitButton.defaultProps = {
  children: null,
  errors: [],
  className: "",
  type: "submit",
  state: 1,
  onClick: () => {},
  onUpdate: () => {},
};

export default SubmitButton;
